import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'onevoice-onevoice',
  template: `
    <p>
      onevoice works!
    </p>
  `,
  styles: [
  ]
})
export class OnevoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
